'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["mode", "onModeChange", "onVideoReplace", "onVideoRemove"];
import PropTypes from 'prop-types';
import { path } from '../../utils/iterables';
import { VideoOverlayTypes } from '../../constants/video';
import { PopoverBodyMode } from '../../constants/popover';
import withFormInfo from '../hoc/withFormInfo';
import withCtaInfo from '../hoc/withCtaInfo';
import VideoPopoverBodyLite from './VideoPopoverBodyLite';
import VideoPopoverBodyEdit from './VideoPopoverBodyEdit';
import { jsx as _jsx } from "react/jsx-runtime";
const EnhancedVideoPopoverBodyEdit = withFormInfo(withCtaInfo(VideoPopoverBodyEdit));
const propTypes = {
  mode: PropTypes.oneOf(Object.values(PopoverBodyMode)),
  video: PropTypes.object,
  onModeChange: PropTypes.func.isRequired,
  onVideoReplace: PropTypes.func.isRequired,
  onVideoRemove: PropTypes.func.isRequired
};
const defaultProps = {
  mode: PopoverBodyMode.PREVIEW
};
function VideoPopoverBodyBranch(props) {
  const {
      mode,
      onModeChange,
      onVideoReplace,
      onVideoRemove
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  if (mode === PopoverBodyMode.PREVIEW) {
    const handleEdit = () => {
      onModeChange(PopoverBodyMode.EDIT);
    };
    return /*#__PURE__*/_jsx(VideoPopoverBodyLite, {
      onEdit: handleEdit,
      onReplace: onVideoReplace,
      onRemove: onVideoRemove
    });
  }
  const handleClose = () => {
    onModeChange(PopoverBodyMode.PREVIEW);
  };
  const conversionAssetGuid = path(['conversion_asset', 'id'], props.video);
  const conversionAssetType = path(['conversion_asset', 'type'], props.video);
  let ctaGuid;
  let formGuid;
  if (conversionAssetType === VideoOverlayTypes.CTA) {
    ctaGuid = conversionAssetGuid;
  } else if (conversionAssetType === VideoOverlayTypes.FORM) {
    formGuid = conversionAssetGuid;
  }
  return /*#__PURE__*/_jsx(EnhancedVideoPopoverBodyEdit, Object.assign({}, rest, {
    ctaGuid: ctaGuid,
    formGuid: formGuid,
    fetchOnMount: true,
    onReplace: onVideoReplace,
    onClose: handleClose
  }));
}
VideoPopoverBodyBranch.propTypes = propTypes;
VideoPopoverBodyBranch.defaultProps = defaultProps;
VideoPopoverBodyBranch.displayName = 'VideoPopoverBodyBranch';
export default VideoPopoverBodyBranch;